import { Box, Button, Typography, Modal } from "@mui/material";
import { style, header, iconWrapper } from "./modalStyles";
import { Close } from "@mui/icons-material";
import offlineIcon from "../Assets/offline.svg";

const OfflineModal = ({ open, onClose }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Box sx={header}>
          <Close onClick={onClose} />
        </Box>
        <Box>
          <Box sx={iconWrapper}>
            <img src={offlineIcon} alt="Offline" />
          </Box>
          <Typography variant="h6" mb={1} align="center">
            Elektrobank is unavailable
          </Typography>
          <Typography variant="body1" mb={2} align="center">
            The Elektrobank 14 unavailable, please try again later. This may occur if
            there is no active internet connection to your home or you have recently
            changed your Wi-Fi password. Please contact your installer if this
            warning persists.
          </Typography>
          <Button onClick={onClose} variant="outlined" size="large" fullWidth>
            Dismiss
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default OfflineModal;
